import { formatUUID } from '@frontend/string';

export const formatResultsPrimaryKeys = <T>(primaryKey: keyof T, results: T[] = []) =>
  results
    .map((item) => formatUUID(item[primaryKey] as string | undefined))
    .filter((id): id is NonNullable<string> => !!id);
